module.exports = __webpack_public_path__ + "static/media/whats.babdae7b.svg";